import { IFormData } from '../../components/FormHelper/FormHelper.types';
import { BaseApiResponse } from '../../types/api.types';
import { IChatRoom } from '../../types/chat.types';
import instance from './axios';

const ENDPOINTS = {
  CHAT_ROOM: '/chat-rooms',
  UNREAD_COUNT: '/unread-count',
};

const getChatRoom = () => {
  return instance.get<BaseApiResponse>(ENDPOINTS.CHAT_ROOM);
};

const getChatRoomDetail = (id: number) => {
  return instance.get<{ data: IChatRoom }>(ENDPOINTS.CHAT_ROOM + '/' + id);
};

const getChatRoomMessages = (id: number, page: number = 1, from: string) => {
  return instance.get<BaseApiResponse>(
    ENDPOINTS.CHAT_ROOM + '/' + id + '/messages',
    {
      params: {
        page,
        from: from,
      },
    }
  );
};

const postChatRoomRead = (id: number) => {
  return instance.post<BaseApiResponse>(
    ENDPOINTS.CHAT_ROOM + '/' + id + '/read'
  );
};

const postCreateChatRoom = (data?: IFormData) => {
  return instance.post<BaseApiResponse>(ENDPOINTS.CHAT_ROOM, data);
};

const postSendMessage = (id: number, data: IFormData) => {
  return instance.post<BaseApiResponse>(
    ENDPOINTS.CHAT_ROOM + '/' + id + '/send',
    data,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      transformRequest: () => {
        return data;
      },
    }
  );
};

const getUnreadMessage = () => {
  return instance.get<BaseApiResponse>(
    ENDPOINTS.CHAT_ROOM + ENDPOINTS.UNREAD_COUNT
  );
};

const ChatRoomApi = {
  getChatRoom,
  getChatRoomDetail,
  getChatRoomMessages,
  postChatRoomRead,
  postCreateChatRoom,
  postSendMessage,
  getUnreadMessage,
};

export default ChatRoomApi;
